import { render, staticRenderFns } from "./settingsApp.vue?vue&type=template&id=fb129624&scoped=true&"
import script from "./settingsApp.vue?vue&type=script&lang=js&"
export * from "./settingsApp.vue?vue&type=script&lang=js&"
import style0 from "./settingsApp.vue?vue&type=style&index=0&id=fb129624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb129624",
  null
  
)

export default component.exports